import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { changeLang, locale } from '../utils';

import arButtons from './arabic/buttons.json';
import arErrors from './arabic/errors.json';
import arFields from './arabic/fields.json';
import arPageTitles from './arabic/pageTitles.json';
import arSideMenu from './arabic/sideMenu.json';
import arWarnings from './arabic/warnings.json';
import arOther from './arabic/other.json';
import arTables from './arabic/tables.json';
import enButtons from './english/buttons.json';
import enErrors from './english/errors.json';
import enFields from './english/fields.json';
import enPageTitles from './english/pageTitles.json';
import enSideMenu from './english/sideMenu.json';
import enWarnings from './english/warnings.json';
import enOther from './english/other.json';
import enTables from './english/tables.json';
import enForm from './english/form.json';
import arForm from './arabic/form.json';

changeLang(locale);

const resources = {
  en: {
    translation: {
      ...enButtons,
      ...enErrors,
      ...enFields,
      ...enPageTitles,
      ...enSideMenu,
      ...enWarnings,
      ...enOther,
      ...enTables,
      ...enForm
    }
  },
  ar: {
    translation: {
      ...arButtons,
      ...arErrors,
      ...arFields,
      ...arPageTitles,
      ...arSideMenu,
      ...arWarnings,
      ...arOther,
      ...arTables,
      ...arForm
    }
  }
};

i18n.use(initReactI18next)
  .init({
    resources,
    lng: locale,
    keySeparator: '.',
    interpolation: {
      escapeValue: false
    }
  });


export function translateCell(cell) {
  return (i18n.t(cell));
}

export default i18n;
